document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll("form.nested-nav-link");

  forms.forEach((form) => {
    const submitButton = form.querySelector("#submit-button");
    submitButton.addEventListener("click", function (event) {
      const tabs = form.querySelectorAll(".nav-link");
      tabs.forEach((tab) => {
        tab.querySelector(".badge")?.remove();
      });

      const invalidFields = form.querySelectorAll(".is-invalid");
      invalidFields.forEach((field) => {
        field.classList.remove("is-invalid");
      });

      let hasEmptyRequiredFields = false;

      const requiredFields = form.querySelectorAll("[required]");
      requiredFields.forEach((field) => {
        if (field.style.display === "none") {
          return;
        }

        if (!field.checkValidity()) {
          field.reportValidity();

          field.classList.add("is-invalid");

          hasEmptyRequiredFields = true;
          const tabPane = field.closest(".tab-pane");
          const tabId = tabPane.getAttribute("id");
          const navLink = document.querySelector(`[data-bs-target="#${tabId}"]`);
          if (navLink && !navLink.querySelector(".badge")) {
            const badge = document.createElement("span");
            badge.className = "badge bg-danger rounded-pill ms-2";
            badge.textContent = "!";
            navLink.appendChild(badge);
          }
        }
      });

      if (hasEmptyRequiredFields) {
        event.preventDefault();
      } else {
        form.submit();
      }
    });
  });

  function toggleFields(config) {
    const condition = document.getElementById(config.condition);

    if (!condition) {
      return;
    }

    const conditionValue = condition?.type === "checkbox" ? condition.checked : condition.value;

    Object.values(config.fields)
      .flat()
      .forEach((fieldId) => {
        document.getElementById(fieldId).style.display = "none";
      });

    if (config.fields[conditionValue]) {
      config.fields[conditionValue].forEach((fieldId) => {
        document.getElementById(fieldId).style.display = "block";
      });
    }
  }

  window.toggleFields = toggleFields;
});
